export enum ConsentMethod {
  written = 0,
  verbal = 1,
}

export class ConsentMethodNames {
  static readonly [ConsentMethod.written] = "Written";
  static readonly [ConsentMethod.verbal] = "Verbal";
}